import { makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
  headerText: {
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: '35px',
  },
}));

export const PayoffCardColumnHeaderText = observer(({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="body1" className={classes.headerText}>{children}</Typography>
  )
});